import type { CheckoutCart } from "@dransay/api/models";
import type { useCart } from "~/features/cart/cart.context";

export function buildCheckoutCartFromLiveCart({
	checkoutCart,
	items,
	totalPrice,
	vendor,
	deliveryMethodUuid,
	fulfillmentGroups,
}: {
	checkoutCart: CheckoutCart;
	items: ReturnType<typeof useCart>["items"];
	totalPrice: number;
	vendor: ReturnType<typeof useCart>["vendor"];
	deliveryMethodUuid: string | null;
	fulfillmentGroups: ReturnType<typeof useCart>["fulfillmentGroups"];
}): CheckoutCart {
	return {
		...checkoutCart,
		items: items.map((item) => ({
			id: item.id,
			quantity: item.quantity,
			crushed: item.crushed ?? false,
			priceComparison: item.priceComparison,
			product: {
				id: Number(item.product.id),
				price: item.product.price ?? 0,
				kind: item.product.kind,
				name: item.product.name,
				imageUrl: item.product.imageUrl,
				category: item.product.category,
				packageSize: item.product.packageSize,
			},
		})),
		totalPrice,
		vendor: vendor ?? checkoutCart.vendor,
		deliveryMethodUuid: deliveryMethodUuid ?? checkoutCart.deliveryMethodUuid,
		fulfillmentGroups: fulfillmentGroups ?? checkoutCart.fulfillmentGroups,
	};
}
